/**
 * Build-time environment. Vite exposes only `VITE_`-prefixed env vars to the
 * client bundle — passed via `.env`, `--mode`, or directly in the shell.
 *
 * Defaults target a backend running on localhost:3000. For production, build
 * with `VITE_API_BASE_URL=https://api.your-domain.com npm run build`.
 */
export const env = {
  apiBaseUrl:
    (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, '') ||
    'http://localhost:3000',
};
